<template>
  <div class="test-comet-popup" v-if="showChat">
    <div
        v-if="!isChatOpen"
        @click="toggleChatPopup"
        class="fixed bottom-0 right-4 w-60 text-center py-2 rounded shadow-lg hover:shadow-xl
          cursor-pointer border border-gray-300 hidden md:block bg-gray-100"
    >
      <div class="flex items-center justify-center rounded space-x-2 dark:text-black">
        Nachrichten<i data-feather="chevron-up" class="size-4 ml-2 mt-1"></i>
      </div>
    </div>
    <div
        v-if="isChatOpen || isMobile"
        class="md:fixed md:bottom-0 md:right-4 md:w-80 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200"
        style="z-index: 9999;"
    >
      <div class="flex items-right justify-between px-4 py-2 bg-gray-100 border-b border-gray-300">
        <button @click="toggleChatPopup" class="text-gray-500 hover:text-gray-700">
          ✖
        </button>
      </div>
      <div
          v-if="isInitialized"
          class="overflow-y-auto max-h-[70vh] px-4 py-2"
      >
        <CometChatConversationsWithMessages
            v-if="messagesConfiguration"
            :isMobileView="true"
            :conversationsConfiguration="conversationsConfiguration"
            :messagesConfiguration="messagesConfiguration"
        />
      </div>

      <div v-else class="px-4 py-2">
        <p>Initializing chat, please wait...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { initializeAndLoginCometChat } from "@/services/message/cometchat";
import { CometChatConversationsWithMessages } from "@cometchat/chat-uikit-vue";
import { ConversationsConfiguration, MessagesConfiguration } from "@cometchat/uikit-shared";
import feather from "feather-icons";

export default {
  name: "App",
  components: {
    CometChatConversationsWithMessages
  },
  data() {
    return {
      isInitialized: false,
      isChatOpen: false,
      conversationsConfiguration: null,
      messagesConfiguration: null,
      isMobile: false,
    };
  },
  computed: {
    showChat() {
      return window.innerWidth > 768;
    },
  },
  async mounted() {
    feather.replace();

    this.isMobile = window.innerWidth < 768;

    const userData = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (userData.uuid) {
      this.userLoggedIn = true;
      await initializeAndLoginCometChat(userData);
    }
    try {
      this.conversationsConfiguration = new ConversationsConfiguration({
        disableSoundForMessages : false
      });
      this.messagesConfiguration = new MessagesConfiguration({
        disableTyping : true,
        hideMessageHeader : true,
      });
      this.isInitialized = true;
    } catch (error) {
      console.error("Initialization or login failed:", error);
    }
  },
  methods: {
    toggleChatPopup() {
      this.isChatOpen = !this.isChatOpen;
      this.$nextTick(() => {
        feather.replace();
      });
    }
  },
};
</script>

<style scoped>
.chat-popup {
}
.fixed {
  position: fixed;
}

.overflow-y-auto {
  overflow-y: auto;
}

.w-80 {
  width: 20rem;
}
</style>
